import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ApproveOrRejectSubscriber, GetAllSubscibersApi } from "../../Services/Subscriber";
import DataTable from "react-data-table-component";
import { Spinner, Card, Dropdown, Form, Badge, Button, Row, Col, Modal} from "react-bootstrap";
import TopBar from "../Menu/TopMenu";
import LoadingSpin from "../../common/Spinner";
import { toast } from "react-toastify";
import { getRole, getUserId } from "../../common/GetUserData";
import { FaFilter } from "react-icons/fa";
import SubscriptionFrom from "./SubscriptionForm";
const SubscriberApproval = () => {
    const [statusId, setStatusId] = useState(0);
    const [filterBy, setFilterBy] = useState('Name'); 
    const [filterValue, setFilterValue] = useState('');
    const [showFilterDropdown, setShowFilterDropdown] = useState(false);
    const [loadingAction, setLoadingAction] = useState(null);
    const queryClient = useQueryClient();

    const { data, refetch, isFetching } = useQuery(['getAllSubscribers', statusId],
        () => GetAllSubscibersApi(statusId,filterValue , filterBy), {
        refetchOnWindowFocus: false,
    });

    const { mutate, isLoading } = useMutation(ApproveOrRejectSubscriber, {
        onSuccess: (data) => {
          if (data.ResponseCode === 200) {
            toast.success(data?.ResponseMessage);
          } else {
            toast.warn(data?.ResponseMessage);
          }
          queryClient.invalidateQueries("getAllSubscribers");
          setLoadingAction(null);
        },
        onError: (error) => {
            console.error(error);
            toast.error("Failed.");
            setLoadingAction(null);
        }
      });

    const handleStatusChange = (event) => {
        const selectedStatus = event.target.value;
        setStatusId(Number(selectedStatus));
    };

    const handleFilterChange = (event) => {
        setFilterValue(event.target.value);
    };
    const handleSearch = () => {refetch()}

    const handleApproveOrReject = (id, isApproved, Email, Name) => {
        const data = {
            ID : id,
            Email : Email,
            Name : Name,
            IsApproved : isApproved,
            UserId : getUserId(),
            RoleId : getRole()
        }
        const actionType = isApproved ? `approve-${id}` : `reject-${id}`;
        setLoadingAction(actionType);
        console.log(loadingAction);
        
        mutate(data);
        console.log(data);
        
    };

    const columns = [
        { name: 'Name', selector: row => row.NAME, sortable: true, style: {fontSize: "14px"}},
        { name: 'Mobile', selector: row => row.MOBILE, sortable: true, style: {fontSize: "14px"} },
        // { name: 'Phone', selector: row => row.PHONE, sortable: true },
        { name: 'Email', selector: row => row.EMAIL, sortable: true, style: {fontSize: "14px"} },
        // { name: 'Website', selector: row => row.WEBSITE, sortable: true },
        // { name: 'Address', selector: row => row.ADDRESS, sortable: true },
        // { name: 'Company ID', selector: row => row.COMPANY_ID, sortable: true },
        { name: 'Status', cell: (row) => (
            <Badge pill bg={row.STATUS_ID === 1 ? "success" : "info"}>
                {row.STATUS_ID === 1 ? "Active" : "Pending"}
            </Badge>
        ), style: {fontSize: "14px"}},
    ];
console.log(loadingAction);

    const ExpandedComponent = ({ data }) => (
        <div style={{ padding: "10px 20px", fontSize: "14px" }}>
            <Row className="mb-2">
                <Col xs={12} md={4}>
                    <p><strong>Phone:</strong> {data.PHONE || "NA"}</p>
                </Col>
                <Col xs={12} md={4}>
                    <p><strong>Website:</strong> {data.WEBSITE || "NA"}</p>
                </Col>
                <Col xs={12} md={4}>
                    <p><strong>Address:</strong> {data.ADDRESS || "NA"}</p>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col xs={12} md={4}>
                    <p><strong>Company:</strong> {data.COMPANY || "NA"}</p>
                </Col>
                <Col xs={12} md={4}>
                    <p><strong>Subscription Date:</strong> {data.CREATED_DATE || "NA"}</p>
                </Col>
                
            </Row>
            {data.STATUS_ID === 4 && (
                <Row className="mt-3">
                    <Col>
                        <Button className="me-2 btn-sm text-sm rounded-pill" variant="dark" disabled={loadingAction === `approve-${data.ID}`} onClick={() => handleApproveOrReject(data?.ID, true, data?.EMAIL, data?.NAME)}>
                            {loadingAction === `approve-${data.ID}` ? <LoadingSpin /> : "Approve"}
                        </Button>
                        <Button className="me-2 btn-sm text-sm rounded-pill" variant="danger" disabled={loadingAction === `reject-${data.ID}`} onClick={() => handleApproveOrReject(data?.ID, false, data?.EMAIL, data?.NAME)}>
                            {loadingAction === `reject-${data.ID}` ? <LoadingSpin /> : "Reject"}
                        </Button>
                    </Col>
                </Row>
            )}
        </div>
    );
    console.log("Query data:", data);
    console.log("Is fetching data:", isFetching);
    console.log("Loading action status:", loadingAction);
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
      };
    return (
        <div>
            <TopBar pageTitle={"Subscriber Requests"} />
            <Card className="mt-4 shadow-sm" style={{ padding: '20px' }}>
                <Card.Body>
                <Modal size="xl" show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <SubscriptionFrom />
                    </Modal.Body>
                </Modal>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                    <div style={{display:'flex',flexDirection:'row'}}>
                    <Form.Control 
                            placeholder={`Search ${filterBy}`}
                            style={{marginRight:'10px',width: '200px'}} 
                            onChange={handleFilterChange} 
                        />
                        
                        <Dropdown show={showFilterDropdown} onToggle={() => setShowFilterDropdown(!showFilterDropdown)}>
                            <Dropdown.Toggle variant="outline-dark" id="filter-dropdown" onClick={() => setShowFilterDropdown(prev => !prev)}>
                                <FaFilter />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setFilterBy("Name")}>Name</Dropdown.Item>
                                <Dropdown.Item onClick={() => setFilterBy("Mobile")}>Mobile</Dropdown.Item>
                                <Dropdown.Item onClick={() => setFilterBy("Email")}>Email</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Button style={{marginLeft:'10px'}} variant="dark" onClick={() => refetch()}>Search</Button>
                        </div>
                        <div style={{display:'flex',flexDirection:'row'}}>
                        <Button style={{marginRight:'10px'}} variant="dark" onClick={() => setShow(true)}>New</Button>
                        <Form.Select style={{width: '140px'}} onChange={handleStatusChange}>
                            <option value={0}>ALL</option>
                            <option value={1}>Active</option>
                            <option value={4}>Pending</option>
                        </Form.Select>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        {isFetching ? (
                            <div className="text-center">
                                <LoadingSpin animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </LoadingSpin>
                            </div>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={data || []}
                                pagination
                                highlightOnHover
                                pointerOnHover
                                paginationPerPage={5}
                                responsive 
                                fixedHeader
                                fixedHeaderScrollHeight="400px"
                                noHeader
                                expandOnRowClicked
                                expandableRows
                                expandableRowsComponent={ExpandedComponent}
                                striped
                            />
                        )}
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default SubscriberApproval;
